import styled from 'styled-components';
import { colors } from '../../../../theme/styled';


export const Container = styled.button`
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 0;
  margin: 0 8px 0;
`;

export const Bars = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const Bar = styled.div`
  width: 100%;
  height: 2px;
  background-color: ${colors.white};
`;

export const Cross = styled.div`
  width: 15px;
  height: 15px;
  position: relative;
`;

export const CrossElement = styled.div`
  width: 2px;
  height: 100%;
  position: absolute;
  left: calc(50% - 1px);
  background: ${colors.white};
  transform: rotate(${props => props.reverse ? '-' : ''}45deg);
`;
